import React, { ChangeEventHandler, useState, FocusEventHandler } from 'react';
import { TextField } from '@mui/material';
import { InputAdornment } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { FormikTouched } from 'formik/dist/types';

type Props = {
    label: string;
    name: string;
    type?: string | undefined;
    autoComplete?: string;
    size?: 'small' | 'medium' | undefined;
    margin?: 'dense' | 'normal' | 'none';
    required?: false | boolean;
    value?: string | undefined;
    rows?: number;
    touched?: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined;
    errors?: any;
    disabled?: boolean;
    onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    onBlur?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
};

const FieldText = ({
    label,
    name,
    type,
    autoComplete,
    size,
    margin,
    required,
    rows,
    touched,
    errors,
    value,
    disabled,
    onChange,
    onBlur,
}: Props) => {
    //onChange Formik
    //The variable filedTextFormik must be equal to the variable name of the formik
    //onChange={formik.handleChange}

    const [showPass, setShowPass] = useState(false);

    return (
        <TextField
            id="field"
            autoComplete={autoComplete}
            fullWidth
            multiline={!!rows}
            label={label}
            name={name}
            value={value}
            required={required}
            rows={rows}
            margin={margin}
            type={type === 'password' ? (showPass ? 'text' : 'password') : type}
            disabled={disabled}
            onChange={onChange}
            onBlur={onBlur}
            size={size}
            helperText={touched ? errors : ''}
            error={touched && Boolean(errors)}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        {type === 'password' && (
                            <IconButton
                                onClick={() => setShowPass(!showPass)}
                                aria-label="toggle password"
                                edge="end"
                            >
                                {showPass ? (
                                    <VisibilityOffIcon color="primary" />
                                ) : (
                                    <VisibilityIcon color="primary" />
                                )}
                            </IconButton>
                        )}
                    </InputAdornment>
                ),
            }}
        />
    );
};

export default FieldText;
